import { Injectable, Type } from '@angular/core';

@Injectable()
export abstract class AppDefinedFieldService {
    public abstract getFields(): { [key: string]: Type<any> };
    public abstract getFieldSelectOptions(): { value: string; label: string }[];
}
